import { TECHNICAL_SERVICE_ACTION_TYPES } from "../_constants/technicalService.constants";

const initialState = {
    invitations: [],
    // Which location `invitations` were loaded for, so a view showing another
    // location can tell a stale list from its own.
    locationUid: null,
};

export class TechnicalServiceSelectors {
    static getSatInvitations(state) {
        return state.invitations;
    }

    static getSatInvitationsLocationUid(state) {
        return state.locationUid;
    }
}

export function technicalService(state = initialState, action) {
    switch (action.type) {

        case TECHNICAL_SERVICE_ACTION_TYPES.SET_SAT_INVITATIONS:
            return { ...state,
                invitations: action.invitations,
                locationUid: action.locationUid ?? null,
            };

        default:
            return state;
    }
}
